import { RootState } from '@app/store';

export const selectInvoices = (state: RootState) => state.admin.invoices.invoices;

export const selectGetInvoicesState = (state: RootState) => state.admin.invoices.getInvoicesState;
